
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.provider('customDirectivesPath', function customDirectivesPathProvider() {
        var self = this;
        this.customPath = '~';

        this.$get = [function customDirectivesPathFactory() {
            return self.customPath;
        }];

    });

    directivesModule.provider("datePickerConfig", function () {

        var self = this;
        this.config = {
            dateFormat: "dd.MM.yyyy",
            timeFormat: "h:mm tt"
        };

        this.$get = [function datePickerConfigFactory() {
            return self.config;
        }];
    });

    directivesModule.directive('customDatepicker', ['customDirectivesPath', function (customDirectivesPath) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                id: '@id',
                name: '@name',
                ngModel: '=ngModel',
                minDate: '=minDate',
                maxDate: "=maxDate",
                ngRequired: '=ngRequired',
                ngDisabled: '=ngDisabled',
                appendtoBody: '@appendtoBody',
                onChange: '&onChange',
                textboxClass: '@',
                focusElement: '=focusElement'
            },
            templateUrl: paths.DatePickerView,
            controller: ['$scope', function ($scope) {
                var patt = /Date\(\d+\)/g;
                var pattLongDate = /\d+/g;
                if ($scope.minDate) {
                    if (!($scope.minDate instanceof Date)) {
                        var isminDateMath = patt.test($scope.minDate);
                        if (isminDateMath) {
                            var longMinDate = $scope.minDate.match(pattLongDate);
                            $scope.minDate = new Date(parseInt(longMinDate));
                        }
                    }
                }
                if ($scope.maxDate) {
                    if (!($scope.maxDate instanceof Date)) {
                        var ismaxDateMath = patt.test($scope.maxDate);
                        if (ismaxDateMath) {
                            var longMaxDate = $scope.maxDate.match(pattLongDate);
                            $scope.maxDate = new Date(parseInt(longMaxDate));
                        }
                    }
                }

                if ($scope.ngModel) {
                    var isMath = patt.test($scope.ngModel);
                    if (isMath) {
                        var longDate = $scope.ngModel.match(pattLongDate);
                        $scope.ngModel = new Date(parseInt(longDate));
                    } else {
                        $scope.ngModel = new Date($scope.ngModel);
                    }
                }

                $scope.dateOptions = {
                    formatYear: 'yy',
                    startingDay: 1,
                    showWeeks: false,
                    minDate: $scope.minDate,
                    maxDate: $scope.maxDate
                };

                $scope.$watch('minDate', function (newValue) {
                    $scope.dateOptions.minDate = newValue;
                });

                $scope.$watch('maxDate', function (newValue) {
                    $scope.dateOptions.maxDate = newValue;
                });

                $scope.translation = globalResources;
            }],
            link: function ($scope, element, attrs) {

                $scope.open = function ($event) {
                    var objectDate = angular.element(".uib-datepicker-popup.dropdown-menu");
                    if (objectDate) {
                        objectDate.css("display", "none");
                    }
                    $scope.opened = false;
                    setTimeout(function () {
                        $scope.$apply(function () {
                            $scope.opened = true;
                        });
                    }, 1);

                    $event.preventDefault();
                    $event.stopPropagation();
                };
                $scope.$watch("ngModel", function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        var patt = /Date\(\d+\)/g;
                        var pattLongDate = /\d+/g;
                        var isMath = patt.test(newValue);
                        if (isMath) {
                            var longDate = newValue.match(pattLongDate);
                            $scope.ngModel = new Date(parseInt(longDate));
                        }

                        $scope.onChange();
                    }
                });
                $scope.$watch('focusElement', function (value) {
                    if (value) {
                        element[0].firstElementChild.focus();
                        $scope.focusElement = false;
                    }
                });
            }
        }
    }]);

    directivesModule.directive('uibDatepickerPopupConfig', ['uibDatepickerConfig', function (uibDatepickerConfig) {
        return {
            priority: 1,
            require: 'ngModel',
            link: function (scope, ele, attrs, ctrl) {

                var isDateTimeInputValid = function (dateFormat, value) {
                    var pattString = '^[\\d]{1,2}\\/[\\d]{1,2}\\/[\\d]{4}$';

                    if (dateFormat.indexOf('.') > 0) {
                        pattString = pattString.replace(new RegExp('\\/', 'g'), '.');
                    } else if (dateFormat.indexOf('-') > 0) {
                        pattString = pattString.replace('/', '-');
                    }

                    var patt = new RegExp(pattString);
                    var match = patt.test(value);

                    return match;
                };

                var dateLocallize = uibDatepickerConfig.dateFormat;
                ele.attr('title', dateLocallize);

                ctrl.$parsers.unshift(function (viewValue) {

                    if (typeof viewValue != "object" && viewValue) {

                        var match = isDateTimeInputValid(dateLocallize, viewValue);

                        ctrl.$setValidity('uibDatepickerPopupConfig', match ? true : false);
                        //if viewValue is not a date, does not parse to date time
                        if (!match) {
                            viewValue = undefined;
                        }
                    } else {
                        ctrl.$setValidity('uibDatepickerPopupConfig', true);
                    }
                    return viewValue;
                });
            }
        }
    }]);
})();
